import { render, staticRenderFns } from "./DesignPreview.vue?vue&type=template&id=4a38f94e&scoped=true"
import script from "./DesignPreview.vue?vue&type=script&lang=js"
export * from "./DesignPreview.vue?vue&type=script&lang=js"
import style0 from "./DesignPreview.vue?vue&type=style&index=0&id=4a38f94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38f94e",
  null
  
)

export default component.exports